import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Country, I18nModule } from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';
import { filter, Observable, of, Subscription } from 'rxjs';
import { NgxMaskDirective } from 'ngx-mask';
import { CountriesDropdownComponent } from '../../../../../../../../../../components/form-elements/countries-dropdown/countries-dropdown.component';

@Component({
  selector: 'form-contact',
  standalone: true,
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    FormErrorsModule,
    CountriesDropdownComponent,
    NgxMaskDirective,
  ],
  templateUrl: './form-contact.component.html',
  styleUrl: './form-contact.component.scss',
})
export class FormContactComponent implements OnInit, OnDestroy {
  @Input() form!: FormGroup;
  @Input() countries$: Observable<Country[]> = of([]);

  country?: Country;
  subscription = new Subscription();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.findCountry();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  findCountry() {
    this.subscription.add(
      this.countries$.pipe(filter((countries: Country[]) => countries.length > 0)).subscribe((countries: Country[]) => {
        const diallingCode = this.form.get('dialingCode')?.value;
        const isocode = this.form.get('dialingIsoCode')?.value;

        const country = countries.find(
          (country: Country) => country.diallingCode === diallingCode && country.isocode === isocode,
        );

        if (country) {
          this.setCountry(country);
        }

        this.cdr.detectChanges();
      }),
    );
  }

  setCountry(country: Country) {
    if (country) {
      this.country = country;
      this.form.get('dialingCode')?.setValue(country.diallingCode);
      this.form.get('dialingIsoCode')?.setValue(country.isocode);

      this.form.get('phoneNumber')?.markAsUntouched();
      this.form.get('phoneNumber')?.markAsPristine();
    }
  }

  validateInput(event: KeyboardEvent): void {
    const allowedChars = /[0-9()-]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!allowedChars.test(inputChar)) {
      event.preventDefault();
    }
  }
}
